import { ACCESS_COPY } from '../accessCopy';

/**
 * What "View only" or "Organization admin" means here: a title and two short lines
 * (spec 196 US1). One place for the words, so the band's pill and the top bar's
 * chip, whichever a page shows, say exactly the same thing.
 */
export function StandingDetails({
  kind,
  workspaceName,
}: {
  kind: 'view-only' | 'admin';
  workspaceName: string;
}) {
  const title =
    kind === 'view-only'
      ? ACCESS_COPY.viewOnlyTitle(workspaceName)
      : ACCESS_COPY.adminTitle(workspaceName);
  const lines =
    kind === 'view-only' ? ACCESS_COPY.viewOnlyLines : ACCESS_COPY.adminLines;
  return (
    <>
      <p className="text-foreground text-sm font-medium">{title}</p>
      {lines.map((line) => (
        <p key={line} className="text-muted-foreground text-sm">
          {line}
        </p>
      ))}
    </>
  );
}
